import styled from "styled-components"

export const StyledPortionFormItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  padding: var(--spacing_s, 8px) 16px;

  width: 100%;
  border-radius: 8px;
  background-color: #fff;

  outline: 0.5px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));

  @supports (-webkit-touch-callout: none) {
    outline: 1px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32)) !important;
  }
`

export const PortionLabel = styled.div`
  font-size: 16px;
`

export const StyledPortionInput = styled.input`
  width: 80px;
  padding: 0px 4px;
  text-align: center;
  font-size: 16px;
  height: 44px;

  border: none;
  border-bottom: 1px solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
  background: var(--Schemes-Surface-Container-Lowest, #fff);
  color: var(--Schemes-Primary, #0da3ba);

  &,
  &:focus,
  &:visited,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: var(--color-navy);
    opacity: 0.36;
    font-family: proxima-nova;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: var(--color-navy);
    opacity: 0.36;
    font-family: proxima-nova;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`

export const DisplayCalories = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  border-radius: 4px;
  padding-right: var(--spacing_xs, 6px);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 50.15%,
    rgba(204, 237, 237, 0.72) 100%
  );

  color: var(--Schemes-On-Surface-Variant, #576066);
`
